.messaging-chat-panel-footer {
   padding: 1rem;
   align-items: center;
}

.messaging-chat-panel-footer-body {
   width: 100%;
   box-sizing: border-box;
   border: 1px solid var(--tti-chat-panel-footer-input-border-color);
   border-radius: 1rem;
   transition: border-color 0.3s ease-out;
   box-shadow: var(--bs-box-shadow-sm);

   &:focus-within {
      border-color: var(--tti-chat-panel-footer-input-focus-border-color);
   }
}

.chat-input-box {
   flex: 1;
   padding: 0.75rem;
   min-height: 0;
   max-height: 100px;
   outline: none;
   overflow-y: auto;
   transition: 0.3s ease-out;
   box-sizing: border-box;
   line-height: 1.5;

   &:not(.has-content)::before {
      content: attr(data-placeholder);
      color: #999999;
      pointer-events: none;
      position: absolute;
   }
}

.footer-buttons {
   width: 100%;
   gap: 0.5rem;
   padding: 0.25rem;
}

.messaging-chat-panel-footer-extended {
   display: flex;
   justify-content: center;
   font-size: 12px;
   color: #6e6e6e;
}

@media (max-width: 768px) {
   .messaging-chat-panel-footer {
      display: block !important;
   }

   .chat-input-box {
      width: 100%;
   }

   .footer-buttons {
      justify-content: end;
   }

   .messaging-chat-panel-footer-extended {
      display: block !important;
      justify-content: center;
   }
}

.send-button-wrapper {
   opacity: 0;
   transform: translateX(10px) rotate(-120deg);
   transition:
      opacity 225ms ease-out,
      transform 225ms ease-out;
   pointer-events: none;

   &:not(.visible) {
      visibility: hidden;
   }

   &.visible {
      opacity: 1;
      transform: translateX(0) rotate(0deg);
      pointer-events: auto;
      visibility: visible;
   }
}